import { atom } from 'recoil';

export const toggleExpandAllState= atom({
    key:"ExpandallState",
    default:false,
})